









































































































































import { CvValue, EditorialProject } from '@/models'
import { CV_VALUE_COUNTRY, CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT, CV_VALUE_EDITORIAL_PROJECT_STATUS, CV_VALUE_MATERIAL_TYPE, CV_VALUE_PRODUCTION_MODE } from '@/utils/constants'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    TypeIcon: () => import('@/components/TypeIcon.vue')
  }
})
export default class EditorialProjectDetailModal extends Vue {
  @Prop({ type: Object }) editorialProject: EditorialProject

  private CV_VALUE_PRODUCTION_MODE = CV_VALUE_PRODUCTION_MODE
  private CV_VALUE_EDITORIAL_PROJECT_STATUS = CV_VALUE_EDITORIAL_PROJECT_STATUS
  private CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT = CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT

  private countries: CvValue[] = []
  private productionModes: CvValue[] = []

  // 'YYYY-MM-DD' -> 'DD/MM/YYYY'
  public formatDay(value?: string | null): string {
    return value ? value.split('-').reverse().join('/') : '--'
  }

  private statuses: CvValue[] = []
  private materialTypes: CvValue[] = []

  // The project keeps its material types as a comma-separated list of code ids
  get materialTypeNames(): string[] {
    const codeIds = (this.editorialProject && this.editorialProject.materialTypes) || ''
    return codeIds.split(',').filter(codeId => codeId).map(codeId => {
      const materialType = this.materialTypes.find(item => item.codeId === codeId)
      return (materialType && materialType.name) || codeId
    })
  }

  async created() {
    this.loadCountry()
    this.loadProductionModes()
    this.loadStatuses()
    this.loadMaterialTypes()
  }

  private async loadCountry() {
    this.countries.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY))
  }

  private async loadProductionModes() {
    this.productionModes.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCTION_MODE))
  }

  private async loadMaterialTypes() {
    this.materialTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_MATERIAL_TYPE)
  }

  private async loadStatuses() {
    this.statuses.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_STATUS))
  }

  private getCvValueName(codeId: string, type: string = CV_VALUE_COUNTRY) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return ''
    }
    return typeName
  }

  private generateFileRootFolderUrl(editorialProject: EditorialProject) {
    if (!editorialProject.fileRootFolder || !editorialProject.localCode) {
      return ''
    }
    return encodeURI(`${process.env.VUE_APP_FUNBOX_URL}/apps/files/?dir=/${editorialProject.fileRootFolder}/${editorialProject.localCode}`)
  }

  hideModal() {
    this.$bvModal.hide('editorialProjectDetailModal')
  }
}
